import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../chartTemplate";
import * as d3 from "d3";
import * as crossfilter from "crossfilter2/crossfilter";

//dc.js template
// returns a chart  object  to be rendered by the chart template

const popDistChartFunc = (divRef, ndx) => {
    // a function which rotates the column into  rows
  function regroup(dim, cols) {
    var _groupAll = dim.groupAll().reduce(
      function (p, v) {
        // add
        cols.forEach(function (c) {
          p[c] += v[c];
        });
        return p;
      },
      function (p, v) {
        // remove
        cols.forEach(function (c) {
          p[c] -= v[c];
        });
        return p;
      },
      function () {
        // init
        var p = {};
        cols.forEach(function (c) {
          p[c] = 0;
        });
        return p;
      }
      );
      
    return {
      all: function () {
        return d3.map(_groupAll.value()).entries();
      },
    };
  }
  const pop_by_gender = ndx.dimension((d) => d.gender);

  const grp = pop_by_gender.group().reduce(
    /* callback for when data is added to the current filter results */
    (p, v) => {
      p.totalPop += v.totalPop;
      p.youthpop += v.youthpop;
      return p;
    },
    /* callback for when data is removed from the current filter results */
    (p, v) => {
      p.totalPop -= v.totalPop;
      p.youthpop -= v.youthpop;
      return p;
    },
    /* initialize p */
    () => ({
      totalPop: 0,
      youthpop: 0,
    })
  );

  let compositeChart = dc.compositeChart(divRef);

  const BAR_PADDING = 0.1; // percentage the padding will take from the bar
  const RANGE_BAND_PADDING = 0.1; // padding between 'groups'
  const OUTER_RANGE_BAND_PADDING = 0.1; // padding from each side of the chart

  let sizing = (chart) => {
    chart.width(window.innerWidth).height(window.innerHeight).redraw();
  };

  let resizing = (chart) => (window.onresize = () => sizing(chart));

  let barPadding;
  let scaleSubChartBarWidth = (chart) => {
    let subs = chart.selectAll(".sub");

    if (typeof barPadding === "undefined") {
      // first draw only
      // to percentage
      barPadding = (BAR_PADDING / subs.size()) * 100;
      // each bar gets half the padding
      //barPadding = barPadding;
    }

    let startAt,
      endAt,
      subScale = d3.scaleLinear().domain([0, subs.size()]).range([0, 100]);

    subs.each(function (d, i) {
      startAt = subScale(i + 1) - subScale(1);
      endAt = subScale(i + 1);

      startAt += barPadding;
      endAt -= barPadding;

      d3.select(this)
        .selectAll("rect")
        .attr(
          "clip-path",
          `polygon(${startAt}% 0, ${endAt}% 0, ${endAt}% 100%, ${startAt}% 100%)`
        );
    });
  };
  function remove_empty_bins(source_group, key_to_remove) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          return d.key !== key_to_remove;
        });
      },
    };
  }
    var empty = remove_empty_bins(grp, null);
    var f = d3.format(",.0f"); // create a formating functions
  
    let barChart1 = dc
        .barChart(compositeChart)
        .barPadding(0)
        .transitionDuration(1500)
        .elasticY(true)
        .valueAccessor((d) => {
            return d.value["totalPop"];
        })
        .title((d) => d.key + ` : ${f(d.value["totalPop"])}`)
    // .title((d) => d.key + `[${d.value[0].key}]: ` + d.value[0].value)
        .colors(["#F48287"]);

  let barChart2 = dc
      .barChart(compositeChart)
      .transitionDuration(1500)
      .barPadding(0)
      .elasticY(true)
      .valueAccessor((d) => d.value["youthpop"])

      .title((d) => d.key + ` : ${f(d.value["youthpop"])}`)
    .colors(["#80AED5"]);

  //   let barChart3 = dc
  //     .barChart(compositeChart)
  //     .barPadding(0)
  //     .valueAccessor((d) => d.value[2].value)
  //     .title((d) => d.key + `[${d.value[2].key}]: ` + d.value[2].value)
  //     .colors(["#47a64a"]);

  compositeChart
    .shareTitle(false)
    .dimension(pop_by_gender)
    .width(300)
    .height(150)
    .transitionDuration(1500)
      .group(empty)
      .elasticY(true)
    // .margins({ bottom: 20 })
    .legend(dc.legend().x(70).y(150).itemHeight(10).gap(10).horizontal(true))
    ._rangeBandPadding(RANGE_BAND_PADDING)
    ._outerRangeBandPadding(OUTER_RANGE_BAND_PADDING)
    .x(d3.scaleOrdinal())
    .xUnits(dc.units.ordinal)
    .compose([barChart1.group(empty, "Total"), barChart2.group(empty, "Youth")])
    .on("pretransition", (chart) => {
      scaleSubChartBarWidth(chart);
    })
    .on("filtered", (chart, filter) => {
      console.log(chart, filter);
    })
    .on("preRedraw", (chart) => {
      chart.rescale();
    })
    .on("preRender", (chart) => {
      chart.rescale();
    });
  // .render();
    compositeChart.yAxis().ticks(0);
    // format the the x axis labels
  compositeChart.xAxis().tickFormat(function (v) {
    if (v == "Female") {
      return "Female";
    } else if (v == "Male") {
      return "Male";
    }
  });
  //   sizing(compositeChart);
  //   resizing(compositeChart);
  return compositeChart;
};

export const PopulationDitsChart = (props) => (
  <ChartTemplate
    chartFunction={popDistChartFunc}
    title="Population Distribution"
  />
);
